const  router = [
	{
		path: '/gua',
		component: () => import('../../../pages/gua/Index.vue'),
		meta: {title: '挂单列表'},
		name: 'gua'
	},
];

export default router